import { Component, OnInit } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CONSTANTS } from '../../../../Constants/Constants';
import { MatLabel, MatFormFieldModule } from "@angular/material/form-field";
import { TranslatePipe } from '@ngx-translate/core';
import { ITurnoverToSalesFormGroup } from '../../../../models/collaboration/ITurnoverToSalesFormGroup';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-turnover-to-sales-dialog',
    imports: [   
    TranslatePipe,
    MatButtonModule,
    MatLabel,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
  templateUrl: './turnover-to-sales-dialog.html',
  styleUrl: './turnover-to-sales-dialog.scss'
})
export class TurnoverToSalesDialog implements OnInit {
turnoverToSalesFormGroup!: FormGroup<ITurnoverToSalesFormGroup>;

  constructor(
    public dialogRef: MatDialogRef<TurnoverToSalesDialog, string>,
    private readonly fb: NonNullableFormBuilder,
  ) { }

  ngOnInit(): void {
    this.initializedForm();
  }

  private initializedForm(): void {
    this.turnoverToSalesFormGroup = this.fb.group({
      modificationNotes: this.fb.control('', Validators.required),
    });
  }

  async publish(): Promise<void> {
    if (this.turnoverToSalesFormGroup.invalid) {
      return;
    }
    this.dialogRef.close(this.turnoverToSalesFormGroup?.controls?.modificationNotes?.value ?? CONSTANTS.EMPTY_STRING);
  }
}
